<template>
  <div>
    <span class="eh-page-title">{{ title }}</span>
    <employee-hub-bookmark
      id="bookmark"
      :title="title"
      class="ml-2"
    />
  </div>
</template>

<script>
export default {
  name: "title-with-bookmark",
  props: ["title"],
};
</script>



// WEBPACK FOOTER //
// src/components/TitleWithBookmark.vue